export default "https://cdn-static.gokick.com/assets/78cedee4a9b459fbef408ae219aa3203e6c5e731/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";